import React, { useState, useEffect, useRef } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  setThePayslipCreateAcrions,
  setUserActions,
  setThePayslipRtrievecrions,
  setThePayslipEditActions,
  setClientBranchActions,
} from "../../../Redux/Slice";
import Select from "react-select";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@mui/material/Button";
import $ from "jquery";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useDebouncedEffect from 'use-debounced-effect';


const PaySlipCreate = (props) => {
  const { setShow, show, currentPage, EditId, white_collar, Datamonths, search,page,search_field,selectVa,getlisted } =
    props;
  const dispatch = useDispatch();
  // console.log(EditId, "EditId");

  const initialState = {
    month: "",
    purpose: "",
    user_id: "",
    status: "approved",
  };
  const [Data, setDatas] = useState(initialState);
  const [UserErr, setUserErr] = useState("");
  const [purposeErr, setPurposeEr] = useState("");
  const [monthEr, setMonthERr] = useState("");
  const [fileErr, setFileErr] = useState("");
  const formdat = new FormData();
  const [file, setFile] = useState();
  const [fileUrl, setfileUrl] = useState("");
  const state = useSelector((state) => state);
  const [Options, setOptions] = useState();
  const [multiselect, setMuliselect] = useState([]);

  const [EditValue, setEditVal] = useState([]);
  const [FileSend, setFileSend] = useState(false);
  const [retrieve, setRetrieve] = useState([]);
  const initialStateSearch = {
    UserName: "",
    client: "",
  };
   const [UserCreate , setUserCreate] = useState()

  //-Branch--filter
  const [clientSelectval, setclientSel] = useState();
  const [nameList4, setOptions4] = useState([]);
  const [clientErr, setClientErr] = useState();

  const options = [
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];

  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    UserName: "",
    client: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


  const [UserId, setUserId] = useState();

  const [url, setUrl] = useState();
  console.log(url);
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [payslipSel, setPayslipSa] = useState({
    value: state.NumberCounts.Option3,
    label: "Pending",
  });
  const [PresentUrls, setPresentUrls] = useState([])
  const [PresentUrlsProfile, setpresenturlProfile] = useState({
    ProfileUrls: "",
  })

  const [PasChec, setPassChe] = useState({ cheque: false, passbook: true });
  const [FilterList, setFilterlits] = useState("Client Role");

  const [crop, setCrop] = useState();

  const [UserDetails, setuserdetails] = useState();
  const fixedCropSize = { width: 300, height: 200 };
  const cancel = (e) => {
    setalert(true);

    setFile("");
    setUrl("");
  };
  const [PayslipDocuments, setPayslipDocument] = useState(false)

  const handleInputChangeClinet = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      client: Val,
    });
  };

  useEffect(() => {
    const payload = {
      search: SearchedVal.client,
      page_size: 10,
      page: 1,
    };
    dispatch(setClientBranchActions(payload)); ///----branch--------
  }, [SearchedVal.client]);

  const HandleSelectFilter = (e) => {
    setPayslipSa(e);
    setDatas({
      ...Data,
      status: e.label.toLowerCase(),
    });
  };
  ///---retriev------------------------------------
  useEffect(() => {
    console.log(EditId, "iysoidfh");
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setThePayslipRtrievecrions(payload));
      console.log(state.payslipRetrieve.PaySlipRetrieveData, "states");
    }
  }, []);
  useEffect(() => {
    setRetrieve(state.payslipRetrieve.PaySlipRetrieveData);
  }, [state.payslipRetrieve.PaySlipRetrieveData]);
  useEffect(() => {
    if (
      EditId != "" &&
      EditId != undefined &&
      state.payslipRetrieve.PaySlipRetrieveData != undefined &&
      state.payslipRetrieve.PaySlipRetrieveData.user_id != undefined &&
      state.payslipRetrieve.PaySlipRetrieveData.user_id.id != undefined
    ) {
      setDatas({
        ...Data,
        user_id: UserId,
        month: state.payslipRetrieve.PaySlipRetrieveData.month,
        purpose: state.payslipRetrieve.PaySlipRetrieveData.purpose,
      });
      if (
        state.payslipRetrieve.PaySlipRetrieveData.slip_url != null &&
        state.payslipRetrieve.PaySlipRetrieveData.slip_url != undefined &&
        state.payslipRetrieve.PaySlipRetrieveData.slip_url.media_url !=
        undefined &&
        state.payslipRetrieve.PaySlipRetrieveData.slip_url.media_url != null
      ) {
        setfileUrl(
          state.payslipRetrieve.PaySlipRetrieveData.slip_url.media_url
        );
        setUrl(state.payslipRetrieve.PaySlipRetrieveData.slip_url.media_url);
      }
    }
  }, [state.payslipRetrieve.PaySlipRetrieveData, UserId]);

  useEffect(() => {
    if (
      state.payslipRetrieve.PaySlipRetrieveData != "" &&
      state.payslipRetrieve.PaySlipRetrieveData.user_id != undefined &&
      state.payslipRetrieve.PaySlipRetrieveData.user_id.id != undefined
    ) {
      let objectArray = [];
      let id = "";
      let eachval = [state.payslipRetrieve.PaySlipRetrieveData];
      eachval.forEach((element) => {
        objectArray.push({
          value: element.user_id.id,
          label: element.user_id.first_name.toUpperCase(),
        });
        id = element.user_id.id;
      });
      setUserId(id);
      // console.log(objectArray ,"objectArray");
      setEditVal(objectArray);
    }
  }, [state.payslipRetrieve.PaySlipRetrieveData]);
  // console.log(EditValue, "EditValue", retrieve);

  /////---User---
  useEffect(() => {
    const payload = {
      search: SearchedVal.UserName,
      page_size: 30,
      page: 1,
      white_collar: FilterList == "UDS Role" ? true : false,
      client_id: Data.client_id,
    };
    dispatch(setUserActions(payload));
  }, [SearchedVal.UserName, FilterList, Data.client_id]);

  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      state.ClientBranch.ClientBranchess.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.client]);

  const HandleClientBranches = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    setclientSel(selectedVal);
    setUserCreate({value:"",label:"Select"})
    setDatas({
      ...Data,
      client_id: selectedVal.value,
      user_id: "",

    });


  };

  useEffect(() => {
    setuserdetails(state.Usergetlists.UserList);
  }, [state.Usergetlists.UserList]);

  var objectArray = [];
  var objectArray2 = [];

  useEffect(() => {
    // if (
    //   FilterList == "UDS Role" &&
    //   UserDetails != "" &&
    //   UserDetails != undefined
    // ) {
    //   UserDetails.forEach((element) => {
    //     console.log(element, "element");
    //     objectArray.push({ value: element.id, label: element.first_name });
    //   });
    //   // console.log(objectArray, "objectArray");
    //   setOptions(objectArray);
    // } else if (
    //   FilterList == "Client Role" &&
    //   UserDetails != "" &&
    //   UserDetails != undefined
    // ) {
    //   UserDetails.forEach((element) => {
    //     console.log(element, "element");
    //     objectArray2.push({ value: element.id, label: element.first_name });
    //   });
    //   // console.log(objectArray2, "objectArray2");
    //   setOptions(objectArray2);
    // }

    if (state.Usergetlists.UserList != undefined) {
      state.Usergetlists.UserList.forEach((element) => {
        console.log(element, "element");
        objectArray.push({ value: element.id, label: element.first_name });
      });
      // console.log(objectArray, "objectArray");
      setOptions(objectArray);
    }
  }, [SearchedVal.UserName, state.Usergetlists.UserList]);


  ////-------On--Change---
  const handleSelectChange = (sel) => {
    setUserCreate(sel)
    setDatas({
      ...Data,
      user_id: sel.value,
    });
    setMuliselect(sel);
  };
  ///---Edit----On0---Changes--
  const handleSelectChangeEdit = (sel) => {
    setDatas({
      ...Data,
      user_id: sel.value,
    });

    setEditVal(sel);
    // UserId = sel.value;
    setUserId(sel.value);
  };
  ///----Input----Field---
  const handleInputChangeCreate = (Val) => {
    //console.log(Val, "Values");
    setSearchDebounance({
      ...SearchDebounance,
      UserName: Val,
    });
  };

  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                client: SearchDebounance.client,
                UserName: SearchDebounance.UserName,
            });

        }
    },
    500,
    [SearchDebounance]
);



  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,

        [e.target.name]: e.target.value,
      };
    });
  };
  function getCroppedImg(a, crop, fileName) {
    const image = document.getElementById("localimg");
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    if (crop) {
      canvas.width = crop.width;
      canvas.height = crop.height;
    } else {
      canvas.width = image.width;
      canvas.height = image.height;
    }
    const ctx = canvas.getContext("2d");
    if (crop) {
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
    } else {
      ctx.drawImage(
        image,
        scaleX,
        scaleY,
        image.width * scaleX,
        image.height * scaleY,
        0,
        0,
        image.width,
        image.height
      );
    }

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], "croppedimg.jpg", {
          type: "image/jpeg",
        });
        if (CroppImageViewCount == 1) {
          // setImageField((oldArray) => [
          //   ...oldArray,
          //   String(URL.createObjectURL(croppedFile)),
          // ]);
          //          setImageField(croppedFile);

          setFile(croppedFile);
          // setimgtype((oldArray) => [...oldArray, croppedFile.type]);
          console.log(croppedFile, "croppedFile");
          // setimgfile(croppedFile);
          // setimgtype(croppedFile.type);
          var file = croppedFile;
          var reader = new FileReader();
          reader.onloadend = function () {
            setUrl(reader.result);
          };
          reader.readAsDataURL(file);
        }
        // console.log(croppedFile);
        blob.name = fileName;
        // setCroppImageViewCount(0);
        setCroppImageView(false);
        // window.URL.revokeObjectURL(this.fileUrl);
        let fileUrl = window.URL.createObjectURL(blob);
        console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  }


  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      // console.log(imgsrc, "imgsrc");
    }
  };

  const setCompletedCrop = async (c) => {
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

  const handleFiles = (e) => {
    setFileSend(true);
    selectedImage(e);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setalert(true);
  };
  const handlePassBookChnages = (e, name, value, values) => {
    console.log(value, "skabfiasdiuasib d", name);
    setFilterlits(name);
    setPassChe({
      ...PasChec,
      cheque: value,
      passbook: values,
    });
  };
  $("form").on("change", ".file-upload-field", function () {
    $(this)
      .parent(".file-upload-wrapper")
      .attr(
        "data-text",
        $(this)
          .val()
          .replace(/.*(\/|\\)/, "")
      );
  });

  const HandleChanegsFile = (e) => {
    let Croppedfile = e.target.files[0];
    setPayslipDocument(true);
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml", "application/pdf"];
    const maxSize = 10 * 1024 * 1024;
    const MIN_DIMENSION = 150;


    const generateRandomNumber = () => {
      return Math.floor(Math.random() * 100000);
    };


    const createPresentData = (Croppedfile) => {
      const randomNumber = generateRandomNumber();
      const formattedFilename = `onboarding/payslip/payslip${randomNumber}.${Croppedfile.type.split('/')[1]}`; // Use the file's extension
      const Presentdata = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: Croppedfile.type,
          },
        ],
      };

      return Presentdata;
    };



  
      if (file && allowedTypes.includes(file.type)) {
        if (file.size > maxSize) {
          setCroppImageView(false);
          // toast.error("File size exceeds 10MB. Please upload a smaller image.");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;
    
            // imageElement.addEventListener("load", (imgEvent) => {
            //   const { naturalWidth, naturalHeight } = imgEvent.currentTarget;
    
            //   if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
            //     toast.error("Image must be at least 150 x 150 pixels.");
            //     setCroppImageView(false);
            //     return;
            //   }
              setFile(e.target.files[0]);

              const Presentdata = createPresentData(Croppedfile);
              axios({
                url: PresentUrl,
                method: 'post',
                data: Presentdata,
                headers: {
                  Authorization:
                    "Bearer " + store.getState().users.UserData.session.token,
                },
              })
                .then((response) => {
                  const uploadedFiles = response.data.data;
                  const newUrls = uploadedFiles.map(file => ({
                    url: file,
                    type: Croppedfile.type,
                    putfiles: Croppedfile
                  }));
          
                  // Update PresentUrls state
                  setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
                  setpresenturlProfile({
                    ProfileUrls: String(response.data.data).split("?")[0],
          
                  })
          
                })
                .catch((error) => {
                  console.error('Error uploading files:', error);
                });

            // });
          });
          reader.readAsDataURL(file); 
        }
      } else {
        setCroppImageView(false);
        toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      }



  };
console.log(Data ,"aspiduasd oiasdu Data",getlisted);

  const HandleSubmit = () => {
    var a = 0;

    const fetchUploadFiles = async () => {
      await Promise.all(PresentUrls.map(async (item) => {
        try {
          if(item != undefined && item != null){ 

          const response = await fetch(item.url, {
            method: 'PUT',
            headers: {
              'Content-Type': item.type,
              "x-amz-acl": "public-read"
            },
            body: item.putfiles,
          });

          if (EditId == undefined || EditId == "") {
let togetmonth = new Date(Data.month)
            let CreatedData = {
              month: `${togetmonth.getFullYear()}-${togetmonth.getMonth() +1}-${togetmonth.getDate()}`,
              purpose: Data.purpose,
              user_id: Data.user_id,
              status: Data.status,

              payslip: PresentUrlsProfile.ProfileUrls
            }
            const values =getlisted;
            dispatch(
              setThePayslipCreateAcrions(
                { CreatedData, white_collar, values },
                props.setShow()
              )
            );

          }
          else if (EditId != undefined) {
            let EditedData = {
              month: Data.month,

              purpose: Data.purpose,
              user_id: Data.user_id,
              status: Data.status,

              payslip: PresentUrlsProfile.ProfileUrls
            }

            const payload = {
              formdat: EditedData,
              EditId: EditId,
              white_collar: white_collar,

              month: Datamonths.month,
              year: Datamonths.year,
              search: search,
                                              values :getlisted,

            };
            dispatch(setThePayslipEditActions(payload, props.setShow()));
          }

          setPresentUrls([]);
        }
        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    };

    if (EditId == undefined || EditId == "") {

      if (Data.month == "") {
        setMonthERr("*Month is required");
        a = 1;
      }

      if (Data.purpose == "") {
        setPurposeEr("*Purpose is required");
        a = 1;
      }

      if (Data.user_id == "") {
        setUserErr("*User Name is required");
        a = 1;
      }
      // if (file == undefined) {
      //   setFileErr("*File is required");
      //   a = 1;
      // }

      if (a == 0 && PayslipDocuments == true) {
        fetchUploadFiles()

      }
      else if (a == 0 && PayslipDocuments == false) {
        if (a == 0) {
          formdat.append("data", JSON.stringify(Data));

          formdat.append("payslip", file);
          let togetmonth = new Date(Data.month)

          let CreatedData = {
            // month: togetmonth.getMonth() +1,
            month: `${togetmonth.getFullYear()}-${togetmonth.getMonth() +1}-${togetmonth.getDate()}`,

            purpose: Data.purpose,
            user_id: Data.user_id,
            status: Data.status,

            payslip: file
          }
                   const values =getlisted;
         

          dispatch(
            setThePayslipCreateAcrions(
              { CreatedData, white_collar, values },
              props.setShow()
            )
          );
        }
      }


    } else if (EditId != undefined) {
      if (Data.month == "") {
        setMonthERr("*Month is required");
        a = 1;
      }

      if (Data.purpose == "") {
        setPurposeEr("*Purpose is required");
        a = 1;
      }

      if (Data.user_id == "") {
        setUserErr("*User Name is required");
        a = 1;
      }
      // if (file == undefined) {
      //   setFileErr("*File is required");
      //   a = 1;
      // }

      if (a == 0 && PayslipDocuments == true) {
        fetchUploadFiles()

      }
      else if (a == 0 && PayslipDocuments == false) {
        if (a == 0) {
          formdat.append("data", JSON.stringify(Data));
          if (FileSend) {
            formdat.append("payslip", file);
          }

          let EditedData = {
            month: Data.month,
            purpose: Data.purpose,
            user_id: Data.user_id,
            status: Data.status,

            payslip: PresentUrlsProfile.ProfileUrls
          }

          const payload = {
            formdat: EditedData,
            EditId: EditId,
            white_collar: white_collar,

            month: Datamonths.month,
            year: Datamonths.year,
            search: search,
                                values :getlisted,

          };
          dispatch(setThePayslipEditActions(payload, props.setShow()));
        }
      }

    }
  };

   console.log(UserCreate ,"UserCreate");
   
  return (
    <>
      <div
        className="RoleCreatePopup"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="BeforePopUp" style={{ width: "50%" }}>
          <div className="RolePopups">
            <div className="asds">
              <div class="ModalHeader">
                {EditId == "" ? (
                  <span className="UserCreate"> Payslip </span>
                ) : (
                  <span className="UserCreate"> Payslip </span>
                )}
                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <div className="Modal-Body Modal-bodyUserCRUD">
                <form class="row g-3 form-fields-wrapper">
                  <div class="col-sm-6 field-div">
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ fontSize: "15px" }}
                    >
                      Purpose
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      autoComplete="off"
                      required
                      name="purpose"
                      value={Data.purpose}
                      style={{
                        padding: "10px",
                      }}
                      onChange={(e) => {
                        HandleChanges(e);
                        setPurposeEr("");
                      }}
                    ></input>
                    <p style={{ color: "red", marginTop: "5px" }}>{purposeErr}</p>
                  </div>
                  <div class="col-sm-6 field-div">
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ fontSize: "15px" }}
                    >
                      Month
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="month"
                      class="form-control"
                      autoComplete="off"
                      required
                      name="month"
                      value={Data.month}
                      style={{
                        padding: "10px",
                      }}
                      min={`${new Date().getFullYear()}-01`} // Start of the current year
                      max={`${new Date().getFullYear()}-12`} // End of the current year
                  
                      onFocus={(e) => {
                        e.target.showPicker()
                      }}
                      onChange={(e) => {
                        HandleChanges(e);
                        setMonthERr("");
                      }}
                    ></input>
                    <p style={{ color: "red", marginTop: "5px" }}>{monthEr}</p>
                  </div>
                  <div
                    className="col-sm-6 field-div"
                  // style={{ padding: "0px 12px" }}
                  >
                    <label
                      class="form-label"
                      for="validationCustom01"
                      style={{ fontSize: "15px" }}
                    >
                      Employee Designation
                    </label>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flexDirection: "row",
                        padding: "0px 30px",
                      }}
                    >
                      <label
                        for="validationCustom01"
                        class="form-label"
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          flexDirection: "row",
                        }}
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          onChange={(e) => {
                            handlePassBookChnages(e, "UDS Role", true, false);
                            setDatas({
                              ...Data,
                              client_id: "",
                            });
                          }
                          }
                          checked={PasChec.cheque}
                          style={{ cursor: "pointer" }}
                        />{" "}
                        UDS
                      </label>

                      <label
                        for="validationCustom01"
                        class="form-label"
                        style={{ width: "100%" }}
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          onChange={(e) =>
                            handlePassBookChnages(e, "Client Role", false, true)
                          }
                          checked={PasChec.passbook}
                          style={{ cursor: "pointer" }}
                        />{" "}
                        Client
                      </label>
                    </div>
                  </div>

                  {FilterList != "UDS Role" ? (
                    <div className="col-sm-6 ">
                      <label for="validationCustom01" class="form-label">
                        Client Name
                      </label>

                      <Select
                        className="Selects"
                        styles={{
                          position: "relative",
                          top: "60px",
                          padding: "70vh",
                        }}
                        value={clientSelectval}
                        onChange={(e) => {
                          HandleClientBranches(e);
                          setClientErr("");
                        }}
                        options={nameList4}
                        onInputChange={handleInputChangeClinet}
                        placeholder="search"
                      />
                      <p style={{ color: "red", marginTop: "5px" }}>
                        {clientErr}
                      </p>
                    </div>
                  ) : null}

                  <div className="col-sm-6 ">
                    <label for="validationCustom01" class="form-label">
                      User Name<span style={{ color: "red" }}>*</span>
                    </label>
                    {EditId == undefined || EditId == "" ? (
                      <Select
                        className="Selects"
                        styles={{
                          position: "relative",
                          top: "60px",
                          padding: "70vh",
                        }}
                        onChange={(e) => {
                          handleSelectChange(e);
                          setUserErr("");
                        }}
                        onInputChange={handleInputChangeCreate}
                        options={Options}
                        labelledBy="Select"
                         value={UserCreate}
                      />
                    ) : (
                      <Select
                        className="Selects"
                        styles={{
                          position: "relative",
                          top: "60px",
                          padding: "70vh",
                        }}
                        onChange={(e) => {
                          handleSelectChangeEdit(e);
                          setUserErr("");
                        }}
                        onInputChange={handleInputChangeCreate}
                        options={Options}
                        value={EditValue}
                        labelledBy="Select"
                      />
                    )}

                    <p style={{ color: "red", marginTop: "5px" }}>{UserErr}</p>
                  </div>

                  {/* <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    pay slip
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="file"
                    class="form-control"
                    autoComplete="off"
                    required
                    name="payslipe"
                    value={Data.payslipe}
                    style={{
                      padding: "10px",
                    }}
                    onChange={(e) => {
                      HandleFile(e);
                      setFileErr("");
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{fileErr}</p>
                </div> */}
                  {/* {FilterList == "Client Role" ?  */}

                  <div className="UploadSHEET col-12" style={{ zIndex: "0" }}>
                    <div className="col-12 Uploadningfield">
                      <form class="form">
                        <div
                          class="file-upload-wrapper"
                          data-text="Select your file!"
                          style={{ marginLeft: "-35px" }}
                        >
                          <input
                            name="file-upload-field"
                            type="file"
                            class="file-upload-field"
                            onChange={(e) => {
                              // const file = e.target.files[0];
                              // const fileName = file.name.toLowerCase();
                              HandleChanegsFile(e);
                            }}
                          />
                        </div>
                      </form>

                      <p style={{ color: "red", marginTop: "5px" }}>{fileErr}</p>
                    </div>
                  </div>

                  {/* {EditId != "" ? (
                  <div className="col-sm-3 ">
                    <label for="validationCustom01" class="form-label">
                      Status
                    </label>
                    <Select
                      className="Selects"
                      styles={{
                        position: "relative",
                        top: "60px",
                        zIndex: "100",
                      }}
                      onChange={(e) => {
                        HandleSelectFilter(e);
                      }}
                      value={payslipSel}
                      options={options}

                      // placeholder={"Pending"}
                    />
                  </div>
                ) : null} */}
                </form>
              </div>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={HandleSubmit}
                >
                  Submit
                </button>
                <button class="btn CancelBtn" onClick={(e) => setShow(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <div className="Cropper_Wrapper">
          <div className="Cropper_Inner_Wrapper">
            <ReactCrop
              src={imgsrc}
              crop={crop}
              ruleOfThirds
              onImageLoaded={onImageLoaded}
              onChange={(c) => {
                setCrop(c);
                console.log(c);
              }}
              keepSelection
              // onComplete={(c) => setCompletedCrop(c)}
              cropSize={fixedCropSize}
            >
              <img src={imgsrc} ref={imgRef} id="localimg" />
            </ReactCrop>
            <div className="CropperFooter">
              <button onClick={(e) => setCroppImageView(false)}>Cancel</button>
              <button
                onClick={(e) => setCompletedCrop(crop)}
                style={{ background: "#ef4d39", color: "white" }}
              >
                Save
              </button>
            </div>
          </div>

        </div>
      )}
    </>
  );
};

export default PaySlipCreate;
